import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import { fetchLatestTemplate, fetchIssuedVerificationCodes, fetchDownloadUrl } from './api';

function parseJwt(token) {
  try {
    if (!token) return null;
    const base64 = token.split('.')[1];
    // atob may throw; make it URL-safe
    const json = decodeURIComponent(
      atob(base64.replace(/-/g, '+').replace(/_/g, '/'))
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

export default function Main() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [template, setTemplate] = useState(null);
  const [issuedCodes, setIssuedCodes] = useState([]);
  const [issuedLoading, setIssuedLoading] = useState(false);
  const [issuedError, setIssuedError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    const payload = parseJwt(token);
    const name = payload?.nickname || '';
    setUsername(name ? `${name}님` : '');
    // fetch template once on mount and cache
    (async () => {
      try {
        const r = await fetchLatestTemplate();
        if (r.ok) setTemplate(r.data || null);
      } catch (e) {
        console.error('템플릿 정보 로드 실패', e);
      }
      // fetch issued verification codes for authenticated user
      try {
        setIssuedLoading(true);
        const ir = await fetchIssuedVerificationCodes();
        if (ir.ok) {
          setIssuedCodes(ir.data || []);
        } else {
          setIssuedError(ir.status || 'error');
        }
      } catch (e) {
        setIssuedError(e.message || String(e));
      } finally {
        setIssuedLoading(false);
      }
    })();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    navigate('/');
  };

  async function handleFetchAndDownload(which) {
    try {
      const r = await fetchDownloadUrl(which);
      if (!r.ok || !r.data?.url) {
        alert(r.data?.error || '다운로드 URL을 가져올 수 없습니다.');
        return;
      }
      window.location.href = r.data.url;
    } catch (err) {
      console.error(err);
      alert('다운로드 중 오류가 발생했습니다.');
    }
  }

  return (
    <div className="app-shell">
      <nav className="top-nav">
        <div className="site-title">한일 잉글리쉬 아카데미</div>
        <div className="user-area">
          <span className="user-name">{username}</span>
          <button className="btn-primary small" onClick={handleLogout}>로그아웃</button>
        </div>
      </nav>

      <main className="main-content">
        <div className="login-card" style={{ width: '90%', maxWidth: 1000, margin: '0 auto' }}>
          <div className="download-actions" style={{ marginTop: 40 }}>
            <button
              className="download-btn"
              onClick={() => handleFetchAndDownload('windows')}
              aria-label="Windows 다운로드"
            >
              <div className="download-top">
                <img className="os-img" src={`${process.env.PUBLIC_URL}/images/Windows_logo.png`} alt="Windows" />
                <span className="os-name">Windows</span>
              </div>
              <div className="download-bottom">다운로드</div>
            </button>

            <button
              className="download-btn"
              onClick={() => handleFetchAndDownload('android')}
              aria-label="Android 다운로드"
            >
              <div className="download-top">
                <img className="os-img" src={`${process.env.PUBLIC_URL}/images/Android_logo.webp`} alt="Android" />
                <span className="os-name">Android</span>
              </div>
              <div className="download-bottom">다운로드</div>
            </button>
          </div>
          <div style={{ marginTop: 60 }}>
            <h3>발급된 인증 코드</h3>
            {issuedLoading && <div>로딩 중...</div>}
            {issuedError && <div style={{ color: 'red' }}>에러: {issuedError}</div>}
            {!issuedLoading && !issuedError && (
              <table className="issued-table">
                <thead>
                  <tr>
                    <th>번호</th>
                    <th>코드</th>
                    <th>사용 여부</th>
                    <th>사용 시간</th>
                  </tr>
                </thead>
                <tbody>
                  {issuedCodes.length === 0 && (
                    <tr><td colSpan={4} className="issued-empty">발급된 코드가 없습니다.</td></tr>
                  )}
                  {issuedCodes.map((c, idx) => (
                    <tr key={c.id}>
                      <td data-label="번호">{idx + 1}</td>
                      <td data-label="코드">{c.verification_code}</td>
                      <td data-label="사용 여부">
                        <span
                          className={`status ${c.is_used ? 'used' : 'unused'}`}
                        >
                          {c.is_used ? '✔' : '✖'}
                        </span>
                      </td>
                      <td data-label="사용 시간">{c.used_at || ''}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
